module.exports = __webpack_public_path__ + "static/exterior-2-983e98fe34168935531f9737e1a98c61.jpg";